import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=0ab00cda&scoped=true&"
import script from "./DataField.vue?vue&type=script&lang=js&"
export * from "./DataField.vue?vue&type=script&lang=js&"
import style0 from "./DataField.vue?vue&type=style&index=0&id=0ab00cda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab00cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab00cda')) {
      api.createRecord('0ab00cda', component.options)
    } else {
      api.reload('0ab00cda', component.options)
    }
    module.hot.accept("./DataField.vue?vue&type=template&id=0ab00cda&scoped=true&", function () {
      api.rerender('0ab00cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/components/DataField.vue"
export default component.exports